<template>
    <div>
        <v-data-table :headers="headers" :items="items" hide-default-header hide-default-footer>
            <template v-slot:header>
                <tr><td colspan=7><label-component horizontal="left">■この契約の関係者</label-component></td></tr>
            </template>
            <template v-slot:item.sn="{ index, item }">
                <v-avatar :size="30" color="grey lighten-1"></v-avatar>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                headers: [
                    { text: 'sn', value: 'sn' },
                    { text: '氏名', value: 'destination_user_name' },
                    { text: 'メールアドレス', value: 'destination_email_address' },
                    { text: '会社名', value: 'destination_company_name' },
                    { text: 'アクセスコード有無', value: 'has_access_code' },
                    { text: '備考', value: 'remarks' },
                ],
            };
        },
        props: {
            user: Object,
            items: Array,   // 契約送付先リスト
        },
    };
</script>

<style scoped lang="scss">
    @import '../../../sass/app.scss';
    /* table */
    td {
        border-bottom: solid 1px rgb(0, 0, 0, 0.05);
        padding: 5px 0;
    }
    ::v-deep .v-data-table__empty-wrapper {
        display: none;
    }
</style>
